import Confirm from "./Confirm";

export default class PanelConfirm extends Confirm {

}